import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { Section as MenuSection } from '@atlaskit/menu';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var Section = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return props.children;
  }
  return /*#__PURE__*/React.createElement(MenuSection, _extends({}, props, {
    ref: ref,
    isSideNavSection: true
  }));
});
export default Section;